import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { KeepFocusWrapper } from '@Hooks/KeepFocus';

export default function DropdownContentWrapper(props) {
  const { children, className, horizontalAlignment } = props;

  return (
    <KeepFocusWrapper focusOnMount needKeepFocus>
      <div
        className={classnames(
          className,
          'new-dropdown-content-wrapper',
          `new-dropdown-content-wrapper-${horizontalAlignment}`,
          'new-dropdown-content-wrapper-top-line',
          `new-dropdown-content-wrapper-top-line-${horizontalAlignment}`
        )}>
        {children}
      </div>
    </KeepFocusWrapper>
  );
}

DropdownContentWrapper.defaultProps = {
  horizontalAlignment: 'right',
};

DropdownContentWrapper.propTypes = {
  horizontalAlignment: PropTypes.oneOf(['left', 'right']),
};
